// extracted by mini-css-extract-plugin
export default {"card-container":"CardContainer_card-container__IV+cf"};